export default __webpack_public_path__ + "static/media/(14).5156a2af.jpeg";